// src/services/auth.ts
import http from './http'

export const logoutSuperadmin = async () => {
  return await http.get('/super-admin/sureface-admin-user-logout/')
}
